import myaxios from "../../components/Axios";

export const getBalanceService = () => myaxios.get(`/ajax/balance`)